import { Container, Fab, Grid } from "@mui/material";
import React, { useEffect } from "react";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const ProjectDetail = ({ project }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (project) {
      document.title = `${project.title} | Akasha Khan - Software Developer`;
      return () => {
        document.title = "Akasha Khan | Software Developer & Frontend Engineer";
      };
    }
  }, [project]);

  if (!project) {
    return null;
  }

  return (
    <div className="max1240">
      <Grid container>
        <Grid item xs={12} md={6}>
          <Container>
            <Fab
              onClick={() => navigate(-1)}
              variant="extended"
              sx={{ marginBottom: "10px" }}
            >
              <ArrowBackIcon />
              Home
            </Fab>
            <p
              style={{
                color: "#625b5b",
                fontWeight: "bold",
                marginBlockEnd: "0px",
              }}
            >
              {project.category}
            </p>
            <h2 className="proTitle" style={{ marginTop: "0px" }}>
              {project.title}
            </h2>
            <p
              style={{
                color: "#625b5b",
                fontWeight: "bold",
                marginBlockEnd: "0px",
              }}
            >
              {project.description}
            </p>
          </Container>
        </Grid>
        <Grid item xs={12} md={6} sx={{ alignSelf: "end" }}>
          <Container sx={{ marginTop: "35px" }}>
            <div className="flexCenterDed">
              <div
                style={{
                  marginInlineEnd: "15px",
                  borderBlockStart: "1px solid",
                }}
              >
                <p
                  style={{
                    color: "#000",
                    fontWeight: "bold",
                    marginBlockEnd: "0px",
                  }}
                >
                  Client
                </p>
                <p
                  style={{
                    color: "#000",
                    fontWeight: "500",
                    marginBlock: "0px",
                  }}
                >
                  {project.client}
                </p>
              </div>
              <div
                style={{
                  borderBlockStart: "1px solid",
                }}
              >
                <p
                  style={{
                    color: "#000",
                    fontWeight: "bold",
                    marginBlockEnd: "0px",
                  }}
                >
                  Tech Stack
                </p>
                <p
                  style={{
                    color: "#000",
                    fontWeight: "500",
                    marginBlock: "0px",
                  }}
                >
                  {project.techStack}
                </p>
              </div>
            </div>
            {project.websiteUrl && (
              <div className="">
                <a
                  className="refLinks flexCenterDed"
                  href={project.websiteUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Visit Website <ArrowRightAltIcon />
                </a>
              </div>
            )}
          </Container>
        </Grid>
      </Grid>
      {project.images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={project.title}
          className={project.imageClasses[index] || "sampSS"}
        />
      ))}
    </div>
  );
};

export default ProjectDetail;
